export const ClientDetails = () =>
  import('./ClientDetails').then(module => ({ Component: module.ClientDetails }));
